/* eslint no-undef:0, no-unused-expressions:0, array-callback-return:0 */
import React, { Component } from 'react';

import { Icon, Notice, Button, Dialog } from '@icedesign/base';
import Layout from '@icedesign/layout';
import Menu, { SubMenu, Item as MenuItem } from '@icedesign/menu';

import { connect } from 'react-redux';
import { Link, Redirect, withRouter } from 'react-router-dom';

import cx from 'classnames';
import { enquire } from 'enquire-js';
import FoundationSymbol from 'foundation-symbol';

import { getAuthperiod } from '@/api/DashboardApi';
import { getAuthority } from '@/auth/authority';
import Authorized from '@/auth/Authorized';
import Auths from '@/auth/Auths';
import AboutDialog from '@/components/About/AboutDialog';
import AppWidget from '@/components/AppWidget';
import MQTTMonitor from '@/components/MQTTMonitor';
import ScreenWidget from '@/components/ScreenWidget';
import { formatMessage } from '@/i18n';
import Initializer from '@/initailizer';
import { asideMenuConfig } from '@/menuConfig';
import { setGuestNoticeVisible } from '@/store/actions/GuestActions';
import { setSystemTrialNoticeVisible } from '@/store/actions/SystemActions';
import {
  isTrialVersion,
  isGuest,
  isLicensable,
  isAdvancedTask,
  getProfile,
  isMulti,
} from '@/tool/profile';

import Footer from '../Footer';
import Header from '../Header';
import LayoutHOC from '../LayoutHOC';
import Logo from '../Logo';

import './scss/dark.scss';
import './scss/light.scss';

const { AuthorizedRoute } = Authorized;

/**
 * 根据菜单取得重定向地址.
 */
const redirectData = [];
const getRedirect = item => {
  if (item && item.children) {
    if (item.children[0] && item.children[0].path) {
      redirectData.push({
        from: `${item.path}`,
        to: `${item.children[0].path}`,
      });
      item.children.forEach(children => {
        getRedirect(children);
      });
    }
  }
};
asideMenuConfig.forEach(getRedirect);
// 设置默认的皮肤配置，支持 dark 和 light 两套皮肤配置
// const theme = typeof THEME === 'undefined' ? 'dark' : THEME;

// FIXME: 由于领出钥匙未单独设置权限，是使用的钥匙设置权限，所以后台无法根据是否是任务分发模式有效判断领出页面是否有权限
// 暂时手动处理一下菜单
const menuTask = asideMenuConfig.map(m => {
  if (m.path === '/key') {
    return {
      ...m,
      children: m.children.filter(c => c.path !== '/key/out'),
    };
  }
  return m;
});

@LayoutHOC
@withRouter
class HeaderAsideFooterLayout extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      openDrawer: false,
      isScreen: undefined,
      keybox: false, //  钥匙盒功能是否开启
      authperiod: 30,
      aboutVisible: false,
    };

    this.usingMenu = isAdvancedTask() ? menuTask : asideMenuConfig;

    // console.log(this.usingMenu);
  }

  componentDidMount() {
    this.enquireScreenRegister();

    this.setState({
      keycabinet: getProfile().keycabinet,
      keybox: getProfile().keybox,
    });
    getAuthperiod().then(authperiod => {
      this.setState({
        authperiod: authperiod || 30,
      });
    });
  }

  componentWillUnmount() {
    // EventEmitter.removeAllListeners();
  }

  /**
   * 注册监听屏幕的变化，可根据不同分辨率做对应的处理
   */
  enquireScreenRegister = () => {
    const isMobile = 'screen and (max-width: 720px)';
    const isTablet = 'screen and (min-width: 721px) and (max-width: 1199px)';
    const isDesktop = 'screen and (min-width: 1200px)';

    enquire.register(isMobile, this.enquireScreenHandle('isMobile'));
    enquire.register(isTablet, this.enquireScreenHandle('isTablet'));
    enquire.register(isDesktop, this.enquireScreenHandle('isDesktop'));
  };

  enquireScreenHandle = type => {
    let collapse;
    if (type === 'isMobile') {
      collapse = false;
    } else if (type === 'isTablet') {
      collapse = true;
    } else {
      collapse = this.state.collapse;
    }

    const handler = {
      match: () => {
        this.setState({
          isScreen: type,
          collapse,
        });
      },
      unmatch: () => {
        // handler unmatched
      },
    };

    return handler;
  };

  openSideDrawer = () => {
    this.setState({
      openDrawer: true,
    });
    // document.getElementsByTagName('body')[0].classList.toggle('hide-scroll');

    document.getElementsByTagName('body')[0].classList.add('hide-scroll');
  };

  closeSideDrawer = () => {
    this.setState({
      openDrawer: false,
    });
    document.getElementsByTagName('body')[0].classList.remove('hide-scroll');
  };

  /**
   * 左侧菜单收缩切换
   */
  onMenuClick = () => {
    if (this.state.openDrawer) {
      this.closeSideDrawer();
    }
  };

  /**
   * 当前展开的菜单项
   */
  getOpenKeys = () => {
    const { match } = this.props;
    const matched = match.path;
    let openKeys = [];

    Array.isArray(this.usingMenu) &&
      this.usingMenu.forEach((item, index) => {
        if (matched.startsWith(item.path)) {
          openKeys = [`${index}`];
        }
      });

    return openKeys;
  };

  /**
   * 跳转升级界面
   */
  upgrade = () => {
    if (getProfile().username === 'admin') {
      this.props.history.push({ pathname: '/system/license', state: { bySystem: true } });
    } else {
      Dialog.alert({
        title: formatMessage('system.license.upgrade'),
        content: formatMessage('system.license.expired.notify.admin'),
        locale: { ok: formatMessage('ok') },
        language: formatMessage('language'),
      });
    }
  };

  // 弹出关于窗口
  showAboutDialog = () => {
    this.setState({ aboutVisible: true });
  };

  // 关闭关于窗口
  closeAboutDialog = () => {
    this.setState({ aboutVisible: false });
  };

  render() {
    const {
      location,
      profileResult,
      sdkResult,
      messagesResult,
      trialNoticeVisible,
      guestNoticeVisible,
      dispatch,
      commVersion,
      disableCommUpdater,
      theme,
      wideScreen,
      integrationScreen,
      systemInfo,
    } = this.props;
    const { pathname } = location;
    const { authperiod, aboutVisible } = this.state;

    return (
      <Layout
        style={{ minHeight: '100vh' }}
        className={cx(
          `ice-design-header-aside-footer-${wideScreen ? 'responsive-' : ''}layout-${theme}`,
          {
            'ice-design-layout': true,
            'wide-layout': !!wideScreen,
            'integration-layout': !!integrationScreen,
          }
        )}
      >
        {/* 在这个组件内部做一些系统的初始化配置 */}
        <Initializer
          wrappedComponentRef={com => {
            this.initializer = com;
          }}
          authperiod={authperiod}
        />

        <Header
          theme={theme}
          isMobile={this.state.isScreen !== 'isDesktop'}
          onLogout={() => this.initializer.logout()}
          onShowAbout={this.showAboutDialog}
          profileInfo={profileResult}
          sdkInfo={sdkResult}
          messagesInfo={messagesResult}
          onGetSocketService={() => this.initializer.getSocketService()}
          onReadKey={() => this.initializer.readKeyInfo()}
          onAuthKey={() => this.initializer.onAuthKey()}
          commVersion={commVersion}
          commUpdater={!disableCommUpdater}
          onCommUpdaterChange={this.initializer?.toggleCommUpdater}
        />

        <ScreenWidget />
        {/* TODO: 是否要将App二维码适配到工厂模式FactoryLayout里面 */}
        {profileResult.qrenabled && !profileResult.lite && (
          <AppWidget
            publicip={profileResult.publicip}
            port={profileResult.port}
            qrurl={profileResult.qrurl}
          />
        )}

        <MQTTMonitor pathname={pathname} />

        <Layout.Section className="ice-design-layout-body">
          {this.state.isScreen !== 'isDesktop' && (
            <a className="menu-btn" onClick={this.openSideDrawer}>
              <Icon type="category" size="small" />
            </a>
          )}

          {this.state.openDrawer && (
            <div className="open-drawer-bg" onClick={this.closeSideDrawer} />
          )}

          <Layout.Aside
            width="auto"
            theme={theme}
            className={cx('ice-design-layout-aside', {
              'open-drawer': this.state.openDrawer,
            })}
          >
            {this.state.isScreen !== 'isDesktop' && <Logo />}
            <Menu
              // 高度较小时，菜单内容区域支持滚动
              style={{ width: 200, height: '100%', overflow: 'auto' }}
              onClick={this.onMenuClick}
              selectedKeys={[pathname]}
              defaultSelectedKeys={[pathname]}
              defaultOpenKeys={[`${this.getOpenKeys()}`]}
              mode="inline"
            >
              {this.getNavMenuItems(this.usingMenu)}
            </Menu>
            {/* 侧边菜单项 end */}
          </Layout.Aside>
          {/* 主体内容 */}
          <Layout.Main>
            {/* 这里必须加入一个是否是试用版的渲染判断，否则会带来的隐患时，在正式版下首次没有保存系统码的情况下，首次加载页面会在Store中判断notice应该显示
        而在登录成功后，没有覆盖store中的状态 */}
            {isTrialVersion() && !isGuest() && isLicensable() && (
              <Notice
                animation={false}
                closable
                type="warning"
                title={
                  <div>
                    {formatMessage('system.trial.notice')}
                    {(!isMulti() || getAuthority().includes(Auths.ADMINISTRATOR)) && (
                      <>
                        ，
                        <Button style={{ fontWeight: 'bold' }} shape="text" onClick={this.upgrade}>
                          {formatMessage('system.setting.syscode.upgrade')}
                        </Button>
                      </>
                    )}
                  </div>
                }
                // className="ice-design-layout-body"
                style={{ marginBottom: 10, backgroundColor: '#b2b5b9' }}
                visible={trialNoticeVisible}
                onClose={() => dispatch(setSystemTrialNoticeVisible(false))}
              />
            )}

            {isGuest() && (
              <Notice
                animation={false}
                closable
                title={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    {formatMessage('guest.notice')}
                    <Button
                      style={{ fontWeight: 'bold' }}
                      onClick={() => this.initializer.logout()}
                    >
                      {formatMessage('login')}
                    </Button>
                  </div>
                }
                // 加入非text button后，line-height被撑起，导致图标显示不居中，强制覆盖一下icon的样式；
                className="notice-with-button"
                style={{ marginBottom: 10, backgroundColor: '#b2b5b9' }}
                visible={guestNoticeVisible}
                onClose={() => dispatch(setGuestNoticeVisible(false))}
              />
            )}
            {this.getRouteScreen(this.props.children)}
          </Layout.Main>
        </Layout.Section>
        <Footer />

        <AboutDialog
          systemInfo={systemInfo}
          visible={aboutVisible}
          onClose={this.closeAboutDialog}
        ></AboutDialog>
      </Layout>
    );
  }

  /**
   *  获取一级菜单或者二级菜单
   */
  getSubMenuOrItem = (item, index) => {
    if (item.children && item.children.some(child => child.name)) {
      const childrenItems = this.getNavMenuItems(item.children);

      if (childrenItems && childrenItems.length > 0) {
        return (
          <SubMenu
            key={index}
            title={
              <span style={{ display: 'flex', alignItems: 'center' }}>
                {item.icon ? (
                  typeof item.icon === 'string' ? (
                    <FoundationSymbol size="small" type={item.icon} />
                  ) : item.icon.dark && item.icon.light ? (
                    // TODO: 进一步优化为支持图标string值与require资源两种
                    <img
                      style={{ marginRight: 8 }}
                      src={this.props.theme === 'dark' ? item.icon.dark : item.icon.light}
                      alt=""
                    />
                  ) : null
                ) : null}
                <span className="ice-menu-collapse-hide">
                  {typeof item.name === 'function' ? item.name() : item.name}
                </span>
              </span>
            }
          >
            {childrenItems}
          </SubMenu>
        );
      }
      return null;
    }
    return (
      <MenuItem key={item.path}>
        <Link to={item.path}>
          <span>
            {item.icon ? <FoundationSymbol size="small" type={item.icon} /> : null}
            <span className="ice-menu-collapse-hide">
              {typeof item.name === 'function' ? item.name() : item.name}
            </span>
          </span>
        </Link>
      </MenuItem>
    );
  };

  /**
   *  过滤掉没有权限的菜单项
   */
  getNavMenuItems = menusData => {
    if (!menusData) {
      return [];
    }
    const { keybox, keycabinet } = this.state;
    const unlock_mode = getProfile()?.advanced?.unlock_mode;

    return menusData
      .filter(item => item.name && !item.hideInMenu)
      .map((item, index) => {
        //  当钥匙柜关闭时隐藏钥匙柜管理相关菜单
        if (!keycabinet && item.path === '/cabinet/list') {
          return;
        }
        //  当钥匙盒关闭时隐藏钥匙盒管理相关菜单
        if (!keybox && item.path.indexOf('/box') > -1) {
          return;
        }
        // 当巡检功能关闭时隐藏巡检管理相关菜单
        if (
          (!getProfile().patrol || unlock_mode || (isMulti() && !getProfile().companypatrol)) &&
          item.path.indexOf('/patrol') > -1
        ) {
          return;
        }
        const ItemDom = this.getSubMenuOrItem(item, index);
        return this.checkPermissionMenu(item.authority, ItemDom);
      })
      .filter(item => item);
  };

  /**
   *  获取当前的路由并判断是否有权限方位，没有权限重定向至403
   */
  getRouteScreen = screen => {
    // console.log(screen);
    return this.checkPermissionRoute(
      // 在router.jsx中注入到页面props中的authority属性
      screen.props.authority,
      // 这里期望接收的是真正的组件 - <Component/>
      screen,
      <Redirect to={{ pathname: '/exception/403' }} />
    );
  };

  /**
   *  获取当前的路由并判断是否有权限方位，没有权限重定向至403（官方示例）
   */
  getRouteScreen1 = screen => {
    // console.log(screen)
    return (
      <AuthorizedRoute
        path={screen.props.match.path}
        component={screen.type}
        exact={screen.props.match.isExact}
        authority={screen.props.authority}
        redirectPath="/exception/403"
      />
    );
  };

  /**
   * 菜单权限检查
   */
  checkPermissionMenu = (authority, ItemDom) => {
    if (Authorized.check) {
      const { check } = Authorized;
      return check(authority, ItemDom);
    }
    return ItemDom;
  };

  /**
   * 页面路由权限检查
   */
  checkPermissionRoute = (authority, ItemDom, redirectView) => {
    if (Authorized.check) {
      const { check } = Authorized;
      return check(authority, ItemDom, redirectView);
    }
    return ItemDom;
  };
}

function mapStateToProps(store) {
  return {
    profileResult: store.profileReducer.profile,
    messagesResult: store.profileReducer.messages,
    sdkResult: store.sdkReducer,
    trialNoticeVisible: store.systemReducer.trialNoticeVisible,

    guestNoticeVisible: store.guestReducer.guestNoticeVisible,
    disableCommUpdater: store.systemReducer.disableCommUpdater,
    commVersion: store.systemReducer.commVersion,

    theme: store.systemReducer.wideScreen ? 'light' : store.systemReducer.theme,
    // 如果启动了集成模式，则强制使用宽屏模式
    wideScreen: store.systemReducer.integrationScreen || store.systemReducer.wideScreen,
    integrationScreen: store.systemReducer.integrationScreen,
    systemInfo: store.systemReducer,
  };
}

export default connect(mapStateToProps)(HeaderAsideFooterLayout);
